module.exports = __webpack_public_path__ + "assets/img_byob.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_byob.png
 ** module id = 119
 ** module chunks = 1
 **/